import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/big-kitchen.jpg'
import _imports_1 from '@/assets/images/smile_grand_mother2.png'
import _imports_2 from '@/assets/images/papers.png'
import _imports_3 from '@/assets/images/meals_place.png'


const _hoisted_1 = { class: "home-page" }
const _hoisted_2 = { class: "nav-container" }
const _hoisted_3 = { class: "desktop-menu" }
const _hoisted_4 = {
  class: "hero-section",
  id: "hero"
}
const _hoisted_5 = { class: "hero-image-container" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "급식소",
  class: "hero-main-image"
}, null, -1)
const _hoisted_7 = { class: "hero-overlay" }
const _hoisted_8 = { class: "hero-content" }
const _hoisted_9 = { class: "hero-text-box" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<h1 class=\"hero-main-title text-center\">요양시설 위탁급식</h1><h3 class=\"hero-highlight text-center\">경영 혁신과 경쟁력 강화를 위한<br>프리미엄 위탁급식 솔루션</h3><div class=\"hero-company-info\"><p class=\"company-name\">주식회사 함우리</p><p class=\"company-tagline\">요양시설 급식 전문 파트너</p></div>", 3)
const _hoisted_13 = { class: "hero-actions" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "contact-info" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "contact-label" }, "급식 문의전화"),
  /*#__PURE__*/_createElementVNode("p", { class: "contact-number" }, "1833-7489")
], -1)
const _hoisted_15 = {
  class: "section about-section",
  id: "about"
}
const _hoisted_16 = { class: "container" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "section-header" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "제안 개요"),
  /*#__PURE__*/_createElementVNode("h3", { class: "section-subtitle" }, "급식, 이제는 전략이 필요하다")
], -1)
const _hoisted_18 = { class: "about-content" }
const _hoisted_19 = { class: "about-text" }
const _hoisted_20 = { class: "about-points" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h4", { class: "about-main-title" }, [
  /*#__PURE__*/_createTextVNode(" 복잡한 급식 운영으로부터"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { class: "highlight" }, "완전한 해방"),
  /*#__PURE__*/_createTextVNode("을 제안합니다. ")
], -1)
const _hoisted_22 = { class: "point-item" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "point-text" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "어르신 케어라는 본질에 집중"),
  /*#__PURE__*/_createElementVNode("p", null, "경영 효율성은 높이는 전략적 선택")
], -1)
const _hoisted_24 = { class: "point-item" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "point-text" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "어르신의 건강과 행복"),
  /*#__PURE__*/_createElementVNode("p", null, "그리고 시설의 지속 성장")
], -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "about-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "상담"
  })
], -1)
const _hoisted_27 = {
  class: "section problems-section",
  id: "menu"
}
const _hoisted_28 = { class: "container" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "section-header" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "직영급식의 문제점"),
  /*#__PURE__*/_createElementVNode("h3", { class: "section-subtitle" }, "회계/인력/법적/위생 관리의 삼중고")
], -1)
const _hoisted_30 = { class: "problems-grid" }
const _hoisted_31 = { class: "problem-card smooth-hover" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("h4", null, "복잡한 회계 처리", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("복잡한 회계 처리, 인력 관리의 어려움,"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 날로 강화되는 법적·위생 규제로"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 시설장님의 어깨는 더욱 무거워지고 있습니다.")
], -1)
const _hoisted_34 = { class: "problem-card smooth-hover" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("h4", null, "잉여금처리의 투명성 이슈", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("식재료비 수입에서 발생하는 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("잉여금 처리 방식의 불명확성으로 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("회계 감사와 평가에서 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("취약점으로 지적될 수 있습니다.")
], -1)
const _hoisted_37 = { class: "problem-card smooth-hover" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("h4", null, "가중되는 행정 리스크", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("집단급식소 법적 규제 위반 시 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 최대 1,000만원 과태료, 영업정지, "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("식중독 발생 시 민형사 책임까지 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("시설장님께 부담이 되는 운영")
], -1)
const _hoisted_40 = /*#__PURE__*/_createStaticVNode("<section class=\"section why-now-section\" id=\"hygiene\"><div class=\"container\"><div class=\"why-now-content\"><div class=\"why-now-text\"><h2 class=\"section-title\">위탁급식, 변화가 필요한 이유</h2><h3 class=\"section-subtitle\">지금이 전환의 적기입니다</h3><div class=\"why-now-points\"><p class=\"main-point\">전문가 집단과의 <span class=\"highlight\">파트너십</span>이 새로운 경쟁력입니다.</p><p class=\"sub-point\">복잡한 급식 운영은 함우리에게 맡기고 어르신 케어에 집중하는 현명한 선택</p><p class=\"sub-point\">시설 운영의 복잡성과 위험 관리의 한계</p></div></div><div class=\"why-now-image\"><img src=\"" + _imports_2 + "\" alt=\"기술 혁신\"></div></div></div></section><section class=\"section core-reasons-section\" id=\"management\"><div class=\"core-reasons-background\"><img src=\"" + _imports_3 + "\" alt=\"프리미엄 식재료\" class=\"core-reasons-bg-image\"></div><div class=\"container\"><div class=\"section-header\"><h2 class=\"section-title\">위탁급식 도입의 8가지 핵심 이유</h2></div><div class=\"reasons-grid\"><div class=\"reason-card smooth-hover\"><div class=\"reason-number\">01</div><h4 class=\"reason-title\">재무적 효율성</h4><div class=\"reason-content\"><h5>한 장의 세금계산서로 100% 비용처리</h5><p>복잡한 식재료비, 인건비, 운영비가 아닌 단일 위탁급식비로 <br>간결하고 투명한 회계 처리가 가능합니다.</p><ul><li>잉여금문제, 회계 처리 부담 해소</li><li>예측 가능한 재무 관리로 경영 안정</li></ul></div></div><div class=\"reason-card smooth-hover\"><div class=\"reason-number\">02</div><h4 class=\"reason-title\">법적/행정 리스크 완전 해소</h4><div class=\"reason-content\"><h5>법적 기준 100% 준수</h5><p>집단급식소 설치신고, 보존식 관리, 위생관리 등 <br>모든 법적 기준에 대한 완벽한 컴플라이언스를 보장합니다.</p><ul><li>위생관리/행정서류 전문가 전담</li><li>법적 책임에서 완전 보호</li></ul></div></div><div class=\"reason-card smooth-hover\"><div class=\"reason-number\">03</div><h4 class=\"reason-title\">입소자 만족도 극대화</h4><div class=\"reason-content\"><h5>전문 영양사 맞춤식단 제공</h5><p>국가공인 영양사가 작성한 영양학적으로 완벽한 균형식으로 <br>어르신의 건강 상태를 고려한 맞춤형 식단을 제공합니다.</p><ul><li>질환별/연령별 및 연하곤란 식단 차별화</li><li>보호자 신뢰도 상승과 입소 경쟁력 강화</li></ul></div></div><div class=\"reason-card smooth-hover\"><div class=\"reason-number\">04</div><h4 class=\"reason-title\">프리미엄 식재료 공급</h4><div class=\"reason-content\"><h5>삼성웰스토리와의 프리미엄 공급망</h5><p>국내 최대 식자재 유통사와의 전략적 파트너십으로 <br>안정적인 식재료 수급과 품질 보증이 가능합니다.</p><ul><li>신선하고 안전한 식재료</li><li>합리적인 비용의 프리미엄 식자재</li></ul></div></div><div class=\"reason-card smooth-hover\"><div class=\"reason-number\">05</div><h4 class=\"reason-title\">본업 집중 환경 조성</h4><div class=\"reason-content\"><h5>식자재/인력/위생 업무에서 완전 해방</h5><p>복잡한 급식 관련 업무의 부담에서 벗어나 시설 운영의 핵심 가치에 <br>더 많은 시간과 에너지를 투자하세요.</p><ul><li>어르신 케어라는 본질적 업무에 집중 가능</li><li>업무 효율성과 시간 관리의 혁신</li></ul></div></div><div class=\"reason-card smooth-hover\"><div class=\"reason-number\">06</div><h4 class=\"reason-title\">전문가 철저 대응 시스템</h4><div class=\"reason-content\"><h5>설치신고, 행정서류, 위생 등 전문가 철저 대응</h5><p>집단급식소 관련 모든 법적 의무와 행정 요건을 전문가가 <br>체계적으로 관리합니다.</p><ul><li>집단급식소 설치신고 및 변경신고 대행</li><li>위생관리 및 행정서류 완벽 관리</li></ul></div></div><div class=\"reason-card smooth-hover\"><div class=\"reason-number\">07</div><h4 class=\"reason-title\">기관 이미지 제고</h4><div class=\"reason-content\"><h5>식사 품격과 기관 이미지 제고, 신뢰성 확보</h5><p>프리미엄 식사 제공으로 입소자 만족도와 기관 평판이 향상되며 <br>지속가능한 운영 시스템을 구축합니다.</p><ul><li>고품질 식사로 기관 브랜드 가치 향상</li><li>보호자 신뢰도 증대 및 입소 경쟁력 강화</li></ul></div></div><div class=\"reason-card smooth-hover\"><div class=\"reason-number\">08</div><h4 class=\"reason-title\">운영 위험 완전 이전</h4><div class=\"reason-content\"><h5>식중독, 민형사 책임 등 운영 위험 완전 이전</h5><p>급식 관련 모든 법적 책임과 운영 리스크를 전문업체로 이전하여 <br>위험 부담을 최소화합니다.</p><ul><li>식중독 발생 시 민형사 책임 면제</li><li>컴플라이언스 리스크 완전 해소</li></ul></div></div></div></div></section>", 2)
const _hoisted_42 = {
  class: "section partnership-section",
  id: "contact"
}
const _hoisted_43 = { class: "container" }
const _hoisted_44 = /*#__PURE__*/_createStaticVNode("<div class=\"section-header\"><h2 class=\"section-title\">파트너십 제안과 다음 단계</h2><h3 class=\"section-subtitle\">미래를 위한 전략적 선택</h3><p class=\"partnership-quote\">&quot;함우리와 함께 요양시설의 미래경쟁력을 준비하십시오.&quot;</p><p class=\"partnership-desc\">급식 운영의 모든 부담에서 벗어나 어르신 케어의 본질에 집중하는 선택</p></div>", 1)
const _hoisted_45 = { class: "process-steps" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "step-item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "step-number" }, "1"),
  /*#__PURE__*/_createElementVNode("div", { class: "step-content" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "무료 현장 컨설팅 및 맞춤제안"),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode("현재 상황을 정확히 파악하고 최적의"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("솔루션을 제안합니다")
    ])
  ])
], -1)
const _hoisted_47 = { class: "step-arrow" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "step-item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "step-number" }, "2"),
  /*#__PURE__*/_createElementVNode("div", { class: "step-content" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "계약 및 서비스 설계"),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode("시설 특성에 맞는 서비스 설계와"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("계약을 진행합니다")
    ])
  ])
], -1)
const _hoisted_49 = { class: "step-arrow" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "step-item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "step-number" }, "3"),
  /*#__PURE__*/_createElementVNode("div", { class: "step-content" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "급식 서비스 및 지속적 관리"),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode("전문적인 급식 서비스 제공과"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("지속적인 품질 관리")
    ])
  ])
], -1)
const _hoisted_51 = {
  class: "section inquiry-section",
  id: "inquiry"
}
const _hoisted_52 = { class: "container" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "section-header" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "상담신청"),
  /*#__PURE__*/_createElementVNode("h3", { class: "section-subtitle" }, "전문가와 함께 시작하세요"),
  /*#__PURE__*/_createElementVNode("p", { class: "inquiry-desc" }, "시설에 맞는 최적의 급식 솔루션을 제안해드립니다")
], -1)
const _hoisted_54 = { class: "inquiry-content" }
const _hoisted_55 = { class: "footer-section" }
const _hoisted_56 = { class: "footer-content" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "footer-brand" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "footer-logo" }, "장기요양지원센터"),
  /*#__PURE__*/_createElementVNode("p", { class: "footer-tagline" }, "위탁급식")
], -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "footer-company-info" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "footer-section-title" }, "회사 정보"),
  /*#__PURE__*/_createElementVNode("div", { class: "company-details" }, [
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createElementVNode("strong", null, "(주)함우리")
    ]),
    /*#__PURE__*/_createElementVNode("p", null, "사업자등록번호: 185-81-02287")
  ])
], -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("h4", { class: "footer-section-title" }, "연락처", -1)
const _hoisted_60 = { class: "contact-info" }
const _hoisted_61 = { class: "contact-item" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "contact-details" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "contact-label" }, "전화번호"),
  /*#__PURE__*/_createElementVNode("p", { class: "contact-value" }, "1833-7489")
], -1)
const _hoisted_63 = { class: "contact-item" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "contact-details" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "contact-label" }, "이메일"),
  /*#__PURE__*/_createElementVNode("p", { class: "contact-value" }, "hamwoori25@naver.com")
], -1)
const _hoisted_65 = { class: "contact-item" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "contact-details" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "contact-label" }, "웹사이트"),
  /*#__PURE__*/_createElementVNode("p", { class: "contact-value" }, "https://장기요양지원센터.kr")
], -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("h4", { class: "footer-section-title" }, "사업장 주소", -1)
const _hoisted_68 = { class: "address-info" }
const _hoisted_69 = { class: "address-item" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "address-details" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "address-label" }, "서울 사무실"),
  /*#__PURE__*/_createElementVNode("p", { class: "address-value" }, "서울특별시 송파구 법원로90 파트너스2")
], -1)
const _hoisted_71 = { class: "address-item" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", { class: "address-details" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "address-label" }, "전북 사무실"),
  /*#__PURE__*/_createElementVNode("p", { class: "address-value" }, "전북특별자치도 전주시 덕진구 기지로77")
], -1)
const _hoisted_73 = { class: "footer-bottom" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("p", { class: "copyright" }, "©2025 HAMWOORI Corp. All rights reserved.", -1)
const _hoisted_75 = { class: "footer-links" }

import { onMounted, onUnmounted, ref } from 'vue';
import { useStore } from 'vuex';
import InquiryFormEmbed from '@/components/inquiry/InquiryFormEmbed.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'indexPage',
  setup(__props) {

const store = useStore();
const isScrolled = ref(false);
const mobileMenuOpen = ref(false);

// Menu items array for better management
const menuItems = [
  { title: '제안 개요', section: 'about' },
  { title: '직영급식 문제점', section: 'menu' },
  { title: '변화 필요성', section: 'hygiene' },
  { title: '8가지 핵심 이유', section: 'management' },
  { title: '파트너십 제안', section: 'contact' },
  { title: '상담신청', section: 'inquiry' }
];

const handleScroll = () => {
  isScrolled.value = window.scrollY > 50;
};

// Methods
const scrollToSection = (sectionId: string) => {
  const element = document.getElementById(sectionId)
  if (element) {
    const headerHeight = 80 // 고정된 헤더 높이
    const elementPosition = element.offsetTop - headerHeight
    
    window.scrollTo({
      top: elementPosition,
      behavior: 'smooth'
    })
  }
}

const handleMobileMenuClick = (sectionId: string) => {
  scrollToSection(sectionId)
  mobileMenuOpen.value = false
}

const toggleMobileMenu = () => {
  mobileMenuOpen.value = !mobileMenuOpen.value;
};

const handleContactClick = () => {
  store.commit('showSnackbar', {
    text: "상담신청이 접수되었습니다. 곧 연락드리겠습니다!",
    color: "success"
  });
};

const handleTalkClick = () => {
  store.commit('showSnackbar', {
    text: "카카오톡 상담으로 연결됩니다.",
    color: "info"
  });
  // 실제로는 카카오톡 상담 링크로 이동
};

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};

onMounted(() => {
  window.addEventListener('scroll', handleScroll);
  handleScroll();
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});

const gotoMain = () => {
  window.location.href = 'https://xn--ok0b647ab9cu3avi17b59gjrt.kr';
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", {
      class: _normalizeClass(["header-nav", { 'scrolled': isScrolled.value }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", { class: "logo" }, [
          _createElementVNode("h2", {
            class: "logo-text",
            onClick: gotoMain,
            style: {"cursor":"pointer"}
          }, "장기요양지원센터")
        ]),
        _withDirectives(_createElementVNode("nav", _hoisted_3, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuItems, (item) => {
            return _createVNode(_component_v_btn, {
              key: item.title,
              text: "",
              class: "nav-btn",
              onClick: ($event: any) => (scrollToSection(item.section))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.title), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          }), 64))
        ], 512), [
          [_vShow, _ctx.$vuetify.display.lgAndUp]
        ]),
        _withDirectives(_createVNode(_component_v_btn, {
          icon: "",
          class: "menu-toggle",
          onClick: toggleMobileMenu
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, null, {
              default: _withCtx(() => [
                _createTextVNode("mdi-menu")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.$vuetify.display.mdAndDown]
        ])
      ])
    ], 2),
    _createVNode(_component_v_navigation_drawer, {
      modelValue: mobileMenuOpen.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((mobileMenuOpen).value = $event)),
      temporary: "",
      location: "top",
      class: "mobile-menu-drawer",
      style: { top: '80px' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_list, { class: "mobile-menu-list" }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuItems, (item) => {
              return _createVNode(_component_v_list_item, {
                key: item.title,
                onClick: ($event: any) => (handleMobileMenuClick(item.section)),
                class: "mobile-menu-item"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, { class: "mobile-menu-title" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.title), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["onClick"])
            }), 64))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("section", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_v_btn, {
                  size: "large",
                  color: "primary",
                  class: "inquiry-btn",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (scrollToSection('inquiry'))),
                  "prepend-icon": "mdi-send"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 무료 상담신청하기 ")
                  ]),
                  _: 1
                }),
                _hoisted_14
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_v_icon, {
                  class: "point-icon",
                  color: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-target")
                  ]),
                  _: 1
                }),
                _hoisted_23
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_v_icon, {
                  class: "point-icon",
                  color: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-heart")
                  ]),
                  _: 1
                }),
                _hoisted_25
              ])
            ])
          ]),
          _hoisted_26
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _hoisted_29,
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createVNode(_component_v_icon, {
              class: "problem-icon",
              color: "error"
            }, {
              default: _withCtx(() => [
                _createTextVNode("mdi-calculator")
              ]),
              _: 1
            }),
            _hoisted_32,
            _hoisted_33
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createVNode(_component_v_icon, {
              class: "problem-icon",
              color: "warning"
            }, {
              default: _withCtx(() => [
                _createTextVNode("mdi-alert-circle")
              ]),
              _: 1
            }),
            _hoisted_35,
            _hoisted_36
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createVNode(_component_v_icon, {
              class: "problem-icon",
              color: "error"
            }, {
              default: _withCtx(() => [
                _createTextVNode("mdi-shield-alert")
              ]),
              _: 1
            }),
            _hoisted_38,
            _hoisted_39
          ])
        ])
      ])
    ]),
    _hoisted_40,
    _createElementVNode("section", _hoisted_42, [
      _createElementVNode("div", _hoisted_43, [
        _hoisted_44,
        _createElementVNode("div", _hoisted_45, [
          _hoisted_46,
          _createElementVNode("div", _hoisted_47, [
            _createVNode(_component_v_icon, { color: "primary" }, {
              default: _withCtx(() => [
                _createTextVNode("mdi-arrow-right")
              ]),
              _: 1
            })
          ]),
          _hoisted_48,
          _createElementVNode("div", _hoisted_49, [
            _createVNode(_component_v_icon, { color: "primary" }, {
              default: _withCtx(() => [
                _createTextVNode("mdi-arrow-right")
              ]),
              _: 1
            })
          ]),
          _hoisted_50
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_51, [
      _createElementVNode("div", _hoisted_52, [
        _hoisted_53,
        _createElementVNode("div", _hoisted_54, [
          _createVNode(InquiryFormEmbed)
        ])
      ])
    ]),
    _createElementVNode("footer", _hoisted_55, [
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_56, [
            _createVNode(_component_v_row, { class: "footer-main" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "4",
                  class: "footer-column"
                }, {
                  default: _withCtx(() => [
                    _hoisted_57,
                    _hoisted_58
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "4",
                  class: "footer-column"
                }, {
                  default: _withCtx(() => [
                    _hoisted_59,
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("div", _hoisted_61, [
                        _createVNode(_component_v_icon, {
                          icon: "mdi-phone",
                          size: "18",
                          class: "contact-icon"
                        }),
                        _hoisted_62
                      ]),
                      _createElementVNode("div", _hoisted_63, [
                        _createVNode(_component_v_icon, {
                          icon: "mdi-email",
                          size: "18",
                          class: "contact-icon"
                        }),
                        _hoisted_64
                      ]),
                      _createElementVNode("div", _hoisted_65, [
                        _createVNode(_component_v_icon, {
                          icon: "mdi-web",
                          size: "18",
                          class: "contact-icon"
                        }),
                        _hoisted_66
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "4",
                  class: "footer-column"
                }, {
                  default: _withCtx(() => [
                    _hoisted_67,
                    _createElementVNode("div", _hoisted_68, [
                      _createElementVNode("div", _hoisted_69, [
                        _createVNode(_component_v_icon, {
                          icon: "mdi-map-marker",
                          size: "18",
                          class: "address-icon"
                        }),
                        _hoisted_70
                      ]),
                      _createElementVNode("div", _hoisted_71, [
                        _createVNode(_component_v_icon, {
                          icon: "mdi-map-marker",
                          size: "18",
                          class: "address-icon"
                        }),
                        _hoisted_72
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_73, [
              _createVNode(_component_v_divider, { class: "footer-divider" }),
              _createVNode(_component_v_row, {
                align: "center",
                class: "footer-bottom-content"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "6"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_74
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "6",
                    class: "text-md-end"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_75, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _withModifiers(scrollToTop, ["prevent"]),
                          class: "footer-link"
                        }, "맨위로")
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})